import { render, staticRenderFns } from "./MaterialResources.vue?vue&type=template&id=5bd4d2ca"
import script from "./MaterialResources.vue?vue&type=script&lang=js"
export * from "./MaterialResources.vue?vue&type=script&lang=js"
import style0 from "./MaterialResources.vue?vue&type=style&index=0&id=5bd4d2ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports